var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-info"},[_c(_vm.BaseInfoIcon,{tag:"component"}),_c('div',{staticClass:"content"},[_c('marquee',{staticClass:"body__medium"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }